app.directive('formMediaUpload', [
  '$upload',
  '$filter',
  'pnotifyService',
  function ($upload, $filter, pnotifyService) {
    return {
      restrict: 'E',
      scope: {
        itemId: '@',
        label: '@',
        isRequired: '@',
      },
      require: ['^form'],
      templateUrl: require('../../../../../public/themes/v1/default/views/form.media-upload.html'),
      link: function ($scope, element, attrs, ctrls) {
        var formController = ctrls[0];
        var reset = function () {
          $scope.hasError = false;
          $scope.medias = [];
        };

        reset();
        $scope.$on('form.response.submit', function () {
          reset();
        });

        $scope.$watch(function () {
          return validate();
        });

        $scope.$watch('hasError', function () {
          if ($scope.hasError === true) {
            $scope.errorMessage = $filter(
              'translate',
            )('form.validation.required', { field_name: $scope.label });
            return;
          }
        });

        var validate = function () {
          if (
            (formController.$submitted || formController.submitted) &&
            $scope.isRequired === 'true'
          ) {
            $scope.hasError = $scope.medias.length === 0;
            formController.$invalid = $scope.medias.length === 0;
          } else {
            $scope.hasError = false;
          }
        };

        $scope.openFile = function () {
          var input = element.find('input');
          input.trigger('click');
        };

        $scope.deleteMedia = function (media) {
          var index = $scope.medias.indexOf(media);
          $scope.medias.splice(index, 1);
        };

        $scope.onFileSelect = function ($files) {
          $scope.flash = [];
          if ($files.length == 0) {
            pnotifyService.notify(
              $filter('translate')('media.validation.type'),
              {
                customClass: 'error',
                icon: 'fa fa-exclamation-triangle',
              },
            );
            return;
          }

          if ($files.length > 1) {
            pnotifyService.notify(
              $filter('translate')('media.validation.file_limit.one'),
              {
                customClass: 'error',
                icon: 'fa fa-exclamation-triangle',
              },
            );
            return;
          }

          $scope.imageUploading = true;

          for (var i = 0; i < $files.length; i++) {
            var file = $files[i];
            $scope.uploadMedia(file);
          }
        };

        $scope.uploadMedia = function (image) {
          if (image.size / 1024 / 1024 > 5) {
            pnotifyService.notify(
              $filter('translate')('media.validation.error.file_size'),
              {
                customClass: 'error',
                icon: 'fa fa-exclamation-triangle',
              },
            );
            $scope.imageUploading = false;
            return;
          }

          $scope.upload = $upload
            .upload({
              url: '/api/media',
              method: 'POST',
              data: {
                media: {
                  status: 'temp',
                },
                recaptchable: false,
              },
              file: image,
              fileFormDataName: 'media[image_clip]',
              formDataAppender: function (fd, key, val) {
                if (angular.isArray(val)) {
                  angular.forEach(val, function (v) {
                    fd.append(key, v);
                  });
                } else if (angular.isObject(val)) {
                  angular.forEach(val, function (value, idx2) {
                    fd.append(key + '[' + idx2 + ']', value);
                  });
                } else {
                  fd.append(key, val);
                }
              },
            })
            .then(function (res) {
              var data = res.data;
              if (data.code === 'INVALID_COLORSPACE') {
                pnotifyService.notify(data.message, {
                  customClass: 'error',
                  icon: 'fa fa-exclamation-triangle',
                });
              } else {
                $scope.medias.push(data.data);
              }
            })
            .catch(function () {
              pnotifyService.notify(
                $filter('translate')('media.validation.error.file_size'),
                {
                  customClass: 'error',
                  icon: 'fa fa-exclamation-triangle',
                },
              );
            })
            .finally(function () {
              $scope.imageUploading = false;
            });
        };
      },
    };
  },
]);
